module.exports = __webpack_public_path__ + "static/media/Bistro1.37a921bf.webp";